// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_48-6";
export var headerCell = "_48-2";
export var rowWrapper = "_48-4";
export var stickyAggregationCell = "_48-a";
export var stickyAggregationRow = "_48-7";
export var stickyColumnCell = "_48-9";
export var stickyColumnHeaderCell = "_48-8";
export var table = "_48-1";
export var virtualRowWrapper = "_48-5";
export var virtualTableContainer = "_48-0";
export var white = "_48-3";